import { customEvent } from "goi_common";
import { GOI_PHONE_HREF } from "@/constants/contact";
import { PhoneIcon } from "@/components/PhoneIcon";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

interface ParlorFixedBarProps {
  sidoName: string;
  sigunguName: string;
}

export const ParlorFixedBar = ({
  sidoName,
  sigunguName,
}: ParlorFixedBarProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("prlr_fam_main");
  const regionUrl = `${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/parlors/region/${sidoName}-${sigunguName}/`;

  return (
    <div className="pd-fixed-bar" role="complementary" aria-label="바로가기">
      <p className="pd-fixed-bar__trust">
        한 번뿐인 장례, 자세한 견적부터 받아보세요 · 상담 무료 · 고이장례연구소
      </p>
      <div className="pd-fixed-bar__inner">
        <a
          className="pd-fixed-bar__btn pd-fixed-bar__btn--primary"
          href={GOI_PHONE_HREF}
          onClick={(event) => {
            event.preventDefault();
            customEvent({
              newGtm: {
                path: "prlr_fam_main",
                trigger_and_target: "footer_goi_call",
              },
            });
            void openParlorInquiryModal();
          }}
        >
          <PhoneIcon size={15} />
          24시간 무료 장례 상담
        </a>
        <a
          className="pd-fixed-bar__btn pd-fixed-bar__btn--ghost"
          href={regionUrl}
        >
          근처 장례식장 목록
        </a>
      </div>
    </div>
  );
};
